// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"oY-z","sponsoredTooltipWrapper":"pY-z","sponsoredTooltip":"qY-z","newCard":"rY-z"};